import { render, staticRenderFns } from "./AwardAnswersSearch.vue?vue&type=template&id=09080ee0&scoped=true"
import script from "./AwardAnswersSearch.vue?vue&type=script&lang=js"
export * from "./AwardAnswersSearch.vue?vue&type=script&lang=js"
import style0 from "./AwardAnswersSearch.vue?vue&type=style&index=0&id=09080ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09080ee0",
  null
  
)

export default component.exports